import Button from '@/components/Buttons/Button';
import styled from '@emotion/styled';

export const HeaderButton = styled(Button)`
    width: 16rem;
    font-size: 1.6rem;
`;
